(() => {
  if (customElements.get('layout-controls')) {
    return;
  }

  class LayoutControls extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
      this.attachEvents();
    }

    init() {
      this.buttons = this.querySelectorAll('[data-button]');
      this.mobileBreakpoint = '(max-width: 768px)';
      this.sessionKey = 'grid-layout';

      const isMobileDevices = window.matchMedia(
        this.mobileBreakpoint,
      ).matches;
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const hasGridColumnsParameter = urlParams.has('grid_columns');

      if (!hasGridColumnsParameter) {
        this.updateLayout(true);
      } else {
        const currentLayout = urlParams.get('grid_columns'); 
        
        if (isMobileDevices && currentLayout == 6) {
          this.updateSessionVariable(4);
          this.updateLayout();
        } else {
          this.updateSessionVariable(currentLayout);
        }
      }
    }

    attachEvents() {
      this.debouncedOnResize = debounce(() => {
        const currentLayout = sessionStorage.getItem(this.sessionKey) || 4;
        const isMobileDevices = window.matchMedia(
          this.mobileBreakpoint,
        ).matches;

        if (!isMobileDevices || currentLayout != 6) {
          return
        }

        this.updateSessionVariable(4);
        this.updateLayout();
      }, 100);

      window.addEventListener('resize', this.debouncedOnResize.bind(this));

      this.buttons.forEach(button => {
        button.addEventListener('click', () => {
          if (button.classList.contains('is-active')) {
            return;
          }

          this.updateSessionVariable(button.dataset.gridItems || 4);
          this.updateLayout();
        });
      });

      document.addEventListener('shopify:section:load', this.updateLayout.bind(this));
    }

    updateLayout(flag) {
      this.currentLayout = sessionStorage.getItem(this.sessionKey) || 4;

      if (this.currentLayout == 4 && flag === true) {
        document.querySelector(this.dataset.container)?.classList.remove('is-hidden');

        return;
      }

      this.updateContainer();
      
      this.updateButtons();
    }

    async fetchContainer() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const hasPageParameter = urlParams.has('page');
      const hasGridColumnsParameter = urlParams.has('grid_columns');
      const variantParameterValue = Math.floor(Date.now() * Math.random());

      if (hasPageParameter) {
        urlParams.delete('page');
      }

      if (hasGridColumnsParameter) {
        urlParams.delete('grid_columns');
      }

      urlParams.set('grid_columns', this.currentLayout);
      urlParams.set('variant', variantParameterValue);

      const fetUrl = `${window.location.origin}${window.location.pathname}?${urlParams.toString()}`;
      let containerMarkup = '';

      this.updateURL(urlParams.toString())

      await fetch(fetUrl)
        .then((response) => response.text())
        .then((response) => {
          if (response.status) {
            alert(response.description);
            return;
          }

          containerMarkup = new DOMParser()
          .parseFromString(response, 'text/html')
          .querySelector(this.dataset.container).innerHTML;
        })
        .catch((error) => {
          console.error(error);
        });

      return containerMarkup;
    }

    updateButtons() {
      this.buttons.forEach(button => {
        button.classList.toggle('is-active', button.dataset.gridItems == this.currentLayout);
      });
    }

    async updateContainer() {
      const gridContainer = document.querySelector(this.dataset.container);

      gridContainer.classList.add('is-loading');

      const containerMarkup = await this.fetchContainer();

      if (containerMarkup == '') {
        return;
      }

      gridContainer.innerHTML = containerMarkup;

      gridContainer.classList.remove('is-loading', 'is-hidden');
    }

    updateSessionVariable(layout) {
      sessionStorage.setItem(this.sessionKey, layout);
    }

    updateURL(searchParams) {
      history.pushState(
        { searchParams },
        '',
        `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`,
      );
    }
  
  }

  customElements.define('layout-controls', LayoutControls);
})();
